import PropTypes from 'prop-types';

import { itinerarySideBarPropTypes, selectedOptionsPropTypes } from '../../../propTypes';
import { tourStopoverOptionGroupPropTypes } from '../BookingUpgrades/PropTypes';

export const stopoverOptionsPackagePropTypes = PropTypes.shape({
  errorCode: PropTypes.number,
  itinerarySideBar: itinerarySideBarPropTypes,
  price: PropTypes.number, // previously costPerPerson
  selectedOptions: selectedOptionsPropTypes,
  stopoverOptions: PropTypes.arrayOf(tourStopoverOptionGroupPropTypes),
  stopoverOptionsOptional: PropTypes.bool,
  tourFromDate: PropTypes.string,
  tourToDate: PropTypes.string,
  tourDescription: PropTypes.string, // description
  tournamentName: PropTypes.string, // previously tournament
});

export default null;
